import {
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  ApiService
} from '../../core/api.service';


@Component({
  selector: 'app-coupons',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl:
    './coupons.component.html',

  styleUrl:
    './coupons.component.css'
})
export class CouponsComponent
  implements OnInit {

  restaurants: any[] = [];

  products: any[] = [];

  coupons: any[] = [];

  restaurantId: number | null =
    null;

  loading = false;

  saving = false;

  deletingCouponId:
    number | null = null;

  changingStatusCouponId:
    number | null = null;

  editingCouponId:
    number | null = null;

  error = '';

  success = '';

  form: any = {
    code: '',
    name: '',
    description: '',

    type:
      'PERCENTAGE',

    scope:
      'ALL',

    value:
      null,

    minimumOrder:
      null,

    maxDiscount:
      null,

    usageLimit:
      null,

    usagePerCustomer:
      null,

    startsAt:
      '',

    expiresAt:
      '',

    isActive:
      true,

    productIds:
      []
  };


  constructor(
    private api: ApiService
  ) {}


  ngOnInit(): void {
    this.loadRestaurants();
  }


  loadRestaurants(): void {

    this.api
      .get<any[]>(
        '/restaurants'
      )
      .subscribe({

        next: data => {

          this.restaurants =
            data || [];

          if (
            this.restaurants.length
          ) {
            this.restaurantId =
              Number(
                this.restaurants[0].id
              );

            this.loadAll();
          }
        },

        error: error => {

          this.error =
            error?.error?.message ||
            'Erro ao carregar restaurantes.';
        }
      });
  }


  onRestaurantChange(): void {

    if (
      !this.restaurantId
    ) {
      return;
    }

    this.resetForm();

    this.loadAll();
  }


  loadAll(): void {

    if (
      !this.restaurantId
    ) {
      return;
    }

    this.loadProducts();

    this.loadCoupons();
  }


  loadProducts(): void {

    this.api
      .get<any[]>(
        `/restaurants/${this.restaurantId}/products`
      )
      .subscribe({

        next: data => {
          this.products =
            data || [];
        },

        error: error => {
          this.error =
            error?.error?.message ||
            'Erro ao carregar produtos.';
        }
      });
  }


  loadCoupons(): void {

    if (
      !this.restaurantId
    ) {
      return;
    }

    this.loading = true;

    this.api
      .get<any[]>(
        `/restaurants/${this.restaurantId}/coupons`
      )
      .subscribe({

        next: data => {

          this.coupons =
            data || [];

          this.loading =
            false;
        },

        error: error => {

          this.loading =
            false;

          this.error =
            error?.error?.message ||
            'Erro ao carregar cupons.';
        }
      });
  }


  toggleProduct(
    productId: number
  ): void {

    const index =
      this.form
        .productIds
        .indexOf(
          productId
        );

    if (
      index >= 0
    ) {
      this.form
        .productIds
        .splice(
          index,
          1
        );

      return;
    }

    this.form
      .productIds
      .push(
        productId
      );
  }


  isProductSelected(
    productId: number
  ): boolean {

    return this.form
      .productIds
      .includes(
        productId
      );
  }


  saveCoupon(): void {

    this.error = '';
    this.success = '';

    if (
      !this.restaurantId
    ) {
      this.error =
        'Selecione um restaurante.';

      return;
    }

    if (
      !this.form.code?.trim()
    ) {
      this.error =
        'Informe o código do cupom.';

      return;
    }

    if (
      !this.form.value ||
      Number(
        this.form.value
      ) <= 0
    ) {
      this.error =
        'Informe um valor de desconto válido.';

      return;
    }

    if (
      this.form.scope ===
        'PRODUCTS' &&
      !this.form
        .productIds
        .length
    ) {
      this.error =
        'Selecione pelo menos um produto.';

      return;
    }

    const payload: any = {

      code:
        this.form.code
          .trim()
          .toUpperCase(),

      name:
        this.form.name
          ?.trim() ||
        null,

      description:
        this.form.description
          ?.trim() ||
        null,

      type:
        this.form.type,

      scope:
        this.form.scope,

      value:
        Number(
          this.form.value
        ),

      minimumOrder:
        this.toNullableNumber(
          this.form.minimumOrder
        ),

      maxDiscount:
        this.toNullableNumber(
          this.form.maxDiscount
        ),

      usageLimit:
        this.toNullableNumber(
          this.form.usageLimit
        ),

      usagePerCustomer:
        this.toNullableNumber(
          this.form
            .usagePerCustomer
        ),

      startsAt:
        this.form.startsAt ||
        null,

      expiresAt:
        this.form.expiresAt ||
        null,

      isActive:
        Boolean(
          this.form.isActive
        ),

      productIds:
        this.form.scope ===
          'PRODUCTS'
          ? this.form.productIds
          : []
    };

    this.saving = true;


    /*
     * EDITAR
     */
    if (
      this.editingCouponId
    ) {

      this.api
        .put<any>(
          `/restaurants/${this.restaurantId}/coupons/${this.editingCouponId}`,
          payload
        )
        .subscribe({

          next: () => {

            this.saving =
              false;

            this.success =
              'Cupom atualizado com sucesso.';

            this.resetForm();

            this.loadCoupons();
          },

          error: error => {

            this.saving =
              false;

            this.error =
              error?.error?.message ||
              'Erro ao atualizar cupom.';
          }
        });

      return;
    }


    /*
     * CRIAR
     */
    this.api
      .post<any>(
        `/restaurants/${this.restaurantId}/coupons`,
        payload
      )
      .subscribe({

        next: () => {

          this.saving =
            false;

          this.success =
            'Cupom criado com sucesso.';

          this.resetForm();

          this.loadCoupons();
        },

        error: error => {

          this.saving =
            false;

          this.error =
            error?.error?.message ||
            'Erro ao criar cupom.';
        }
      });
  }


  editCoupon(
    coupon: any
  ): void {

    this.editingCouponId =
      coupon.id;

    this.form = {

      code:
        coupon.code,

      name:
        coupon.name || '',

      description:
        coupon.description ||
        '',

      type:
        coupon.type,

      scope:
        coupon.scope,

      value:
        Number(
          coupon.value
        ),

      minimumOrder:
        coupon.minimumOrder
          ? Number(
              coupon.minimumOrder
            )
          : null,

      maxDiscount:
        coupon.maxDiscount
          ? Number(
              coupon.maxDiscount
            )
          : null,

      usageLimit:
        coupon.usageLimit,

      usagePerCustomer:
        coupon.usagePerCustomer,

      startsAt:
        this.toInputDate(
          coupon.startsAt
        ),

      expiresAt:
        this.toInputDate(
          coupon.expiresAt
        ),

      isActive:
        coupon.isActive,

      productIds:
        (
          coupon.products ||
          []
        ).map(
          (item: any) =>
            item.productId
        )
    };

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }


  cancelEdit(): void {
    this.resetForm();
  }


  toggleCoupon(
    coupon: any
  ): void {

    this.changingStatusCouponId =
      coupon.id;

    this.api
      .put<any>(
        `/restaurants/${this.restaurantId}/coupons/${coupon.id}`,
        {
          isActive:
            !coupon.isActive
        }
      )
      .subscribe({

        next: response => {

          coupon.isActive =
            response?.coupon
              ?.isActive ??
            !coupon.isActive;

          this.changingStatusCouponId =
            null;
        },

        error: error => {

          this.changingStatusCouponId =
            null;

          this.error =
            error?.error?.message ||
            'Erro ao alterar cupom.';
        }
      });
  }


  deleteCoupon(
    coupon: any
  ): void {

    const confirmed =
      confirm(
        `Deseja excluir o cupom "${coupon.code}"?`
      );

    if (
      !confirmed
    ) {
      return;
    }

    this.deletingCouponId =
      coupon.id;

    this.api
      .delete<any>(
        `/restaurants/${this.restaurantId}/coupons/${coupon.id}`
      )
      .subscribe({

        next: () => {

          this.deletingCouponId =
            null;

          this.success =
            'Cupom excluído com sucesso.';

          this.loadCoupons();
        },

        error: error => {

          this.deletingCouponId =
            null;

          this.error =
            error?.error?.message ||
            'Erro ao excluir cupom.';
        }
      });
  }


  resetForm(): void {

    this.editingCouponId =
      null;

    this.form = {
      code: '',
      name: '',
      description: '',

      type:
        'PERCENTAGE',

      scope:
        'ALL',

      value:
        null,

      minimumOrder:
        null,

      maxDiscount:
        null,

      usageLimit:
        null,

      usagePerCustomer:
        null,

      startsAt:
        '',

      expiresAt:
        '',

      isActive:
        true,

      productIds:
        []
    };
  }


  formatMoney(
    value: any
  ): string {

    return Number(
      value || 0
    ).toLocaleString(
      'pt-BR',
      {
        style:
          'currency',

        currency:
          'BRL'
      }
    );
  }


  getDiscountLabel(
    coupon: any
  ): string {

    if (
      coupon.type ===
      'PERCENTAGE'
    ) {
      return `${Number(
        coupon.value
      )}% OFF`;
    }

    return `${this.formatMoney(
      coupon.value
    )} OFF`;
  }


  private toNullableNumber(
    value: any
  ): number | null {

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return null;
    }

    return Number(value);
  }


  private toInputDate(
    value: any
  ): string {

    if (!value) {
      return '';
    }

    const date =
      new Date(value);

    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '';
    }

    return date
      .toISOString()
      .slice(
        0,
        16
      );
  }
}